import React, { Component } from 'react';
import { connect } from 'react-redux';
import actions from '../actions/';
import Finalizar from '../components/finalizar';




const mapStateToProps = (state, ownProps) => {
 
    return state.solicitacao;
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
      
        setAceiteRegulamento: (aceite) =>{
            dispatch(actions.setAceiteRegulamento(aceite));
        },

        setAceite: (aceite) => {
            dispatch(actions.setAceite(aceite));
        },

        handleChangeCaptcha: (e) =>{
            dispatch(actions.handleChangeCaptcha(e.target.value));
        }
    };
};

const FinalizarContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(Finalizar);


export default FinalizarContainer;


// WEBPACK FOOTER //
// ./src/containers/finalizar.js